"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatusEnum = exports.P44AdminOnlyUserFieldsEnum = exports.TenantAndP44AdminUserFieldsEnum = exports.UserTypeEnum = exports.LowercasePaginationSortEnum = exports.PaginationSortEnum = void 0;
var PaginationSortEnum;
(function (PaginationSortEnum) {
    PaginationSortEnum["ASC"] = "ASC";
    PaginationSortEnum["DESC"] = "DESC";
})(PaginationSortEnum = exports.PaginationSortEnum || (exports.PaginationSortEnum = {}));
var LowercasePaginationSortEnum;
(function (LowercasePaginationSortEnum) {
    LowercasePaginationSortEnum["ASC"] = "asc";
    LowercasePaginationSortEnum["DESC"] = "desc";
})(LowercasePaginationSortEnum = exports.LowercasePaginationSortEnum || (exports.LowercasePaginationSortEnum = {}));
var UserTypeEnum;
(function (UserTypeEnum) {
    UserTypeEnum["USER"] = "USER";
    UserTypeEnum["CONTACT_PERSON"] = "CONTACT_PERSON";
    UserTypeEnum["CUSTOMER_INTEGRATION_USER"] = "CUSTOMER_INTEGRATION_USER";
    UserTypeEnum["SYSTEM_USER"] = "SYSTEM_USER";
    UserTypeEnum["COMPANY_CREATOR"] = "COMPANY_CREATOR";
    UserTypeEnum["CLIENT_APPLICATION_USER"] = "CLIENT_APPLICATION_USER";
    UserTypeEnum["DATA_STREAM_USER"] = "DATA_STREAM_USER";
    UserTypeEnum["IAS"] = "IAS";
})(UserTypeEnum = exports.UserTypeEnum || (exports.UserTypeEnum = {}));
var TenantAndP44AdminUserFieldsEnum;
(function (TenantAndP44AdminUserFieldsEnum) {
    TenantAndP44AdminUserFieldsEnum["CREATED_DATE_TIME"] = "createdDateTime";
    TenantAndP44AdminUserFieldsEnum["SUSPENDED_DATE_TIME"] = "suspendedDateTime";
    TenantAndP44AdminUserFieldsEnum["FAMILY_NAME"] = "familyName";
    TenantAndP44AdminUserFieldsEnum["GIVEN_NAME"] = "givenName";
    TenantAndP44AdminUserFieldsEnum["LAKE_ID"] = "lakeId";
    TenantAndP44AdminUserFieldsEnum["LAST_LOGIN_DATE_TIME"] = "lastLoginDateTime";
    TenantAndP44AdminUserFieldsEnum["LAST_MODIFIED_DATE_TIME"] = "lastModifiedDateTime";
    TenantAndP44AdminUserFieldsEnum["USERNAME"] = "username";
})(TenantAndP44AdminUserFieldsEnum = exports.TenantAndP44AdminUserFieldsEnum || (exports.TenantAndP44AdminUserFieldsEnum = {}));
var P44AdminOnlyUserFieldsEnum;
(function (P44AdminOnlyUserFieldsEnum) {
    P44AdminOnlyUserFieldsEnum["CREATED_DATE_TIME"] = "createdDateTime";
    P44AdminOnlyUserFieldsEnum["SUSPENDED_DATE_TIME"] = "suspendedDateTime";
    P44AdminOnlyUserFieldsEnum["FAMILY_NAME"] = "familyName";
    P44AdminOnlyUserFieldsEnum["GIVEN_NAME"] = "givenName";
    P44AdminOnlyUserFieldsEnum["LAKE_ID"] = "lakeId";
    P44AdminOnlyUserFieldsEnum["LAST_LOGIN_DATE_TIME"] = "lastLoginDateTime";
    P44AdminOnlyUserFieldsEnum["LAST_MODIFIED_DATE_TIME"] = "lastModifiedDateTime";
    P44AdminOnlyUserFieldsEnum["USERNAME"] = "username";
    P44AdminOnlyUserFieldsEnum["BASIC_AUTH_MACHINE_USER"] = "basicAuthMachineUser";
    P44AdminOnlyUserFieldsEnum["DEACTIVATED_DATE_TIME"] = "deactivatedDateTime";
    P44AdminOnlyUserFieldsEnum["TENANT_UUID"] = "tenantUuid";
    P44AdminOnlyUserFieldsEnum["USER_TYPE"] = "userType";
})(P44AdminOnlyUserFieldsEnum = exports.P44AdminOnlyUserFieldsEnum || (exports.P44AdminOnlyUserFieldsEnum = {}));
var UserStatusEnum;
(function (UserStatusEnum) {
    UserStatusEnum["ACTIVE"] = "ACTIVE";
    UserStatusEnum["DEACTIVATED"] = "DEACTIVATED";
    UserStatusEnum["SUSPENDED"] = "SUSPENDED";
})(UserStatusEnum = exports.UserStatusEnum || (exports.UserStatusEnum = {}));
